import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

export default function HistoricalBalanceSheetModal({data} :any) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = (e) => {
    e.preventDefault();
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      Is the management team of <strong>{data.company_name}</strong> doing a good job? <a href="" onClick={handleClickOpen}> Learn More</a><br/>
      (The data below is in {data.currency_symbol} currency)
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
          Management Team performance
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            To measure the performance of the company's management team, we start by looking at the ROE and ROIC numbers of the company for the last 10 years.
            ROE and ROIC measure the performance of the company's management team at allocating shareholder capital.
            It is also essential to monitor how the company manages its debt.
          </Typography>
          <Typography gutterBottom>
            The management team is doing a good job if the following is true
            <ul>
              <li>The company has had an ROE of 10% or higher every year for the last 10 years</li>
              <li>The company has had an ROIC of 10% or higher every year for the last 10 years</li>
              <li>The company can pay off its long-term with its current free cash flow in 3 years or less. That is a <strong>Debt Pay Off</strong> of 3 years or less</li>
            </ul>
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Close
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}
